import { useSelector } from 'react-redux';
import { GpsType } from '../../../../../global/components/layout/layout-models';
import { TcsmStates } from '../../../../../root/tcsm-model';
import { MidYearProps, NewHireProps } from '../../../models/arc-epi-props';
import { WhoWillEnrollContentModel } from '../models/who-will-enroll-models';

export function useUpdateEnrollmentWhoWillEnrollContentModel() : WhoWillEnrollContentModel {
	const settings = useSelector<TcsmStates, NewHireProps>(state => state.epiProps?.newHireSettingsState?.epiContent);
	const midYearSettings = useSelector<TcsmStates, MidYearProps>(state => state.epiProps?.midYearSettingsState?.epiContent);

	return {
		...settings,
		gpsType: GpsType.SCHEDULED_HOUR_WHO_WILL_ENROLL,
		whoWillEnrollPageDescription: settings.scheduledHourWhoWillEnrollDescription,
		initialSuccessMessage: midYearSettings?.hoursIncreaseSuccessMessage,
	};
}